import { observer } from 'mobx-react';
import ModalStore from '../../../../../../../../../../../../Modal/Store';
import { LearningCollectionPublishResource } from '../../../../../../Store/Types';
import InviteParticipantStore from '../../../Store';
import { SelectParticipantsState } from '../../../Store/Types';
import ModalContent from './ModalContent';

export interface Props {
  modalStore: ModalStore;
  store: InviteParticipantStore;
  learningCollectionPublishResource: LearningCollectionPublishResource;
  state: SelectParticipantsState;
}

function Modal({ modalStore, store, learningCollectionPublishResource, state }: Props) {
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <ModalContent
          state={state}
          store={store}
          modalStore={modalStore}
          learningCollectionPublishResource={learningCollectionPublishResource}
        />
      );
  }
}

export default observer(Modal);
